import { render, staticRenderFns } from "./MainListFilters.vue?vue&type=template&id=4565e2b6&"
import script from "./MainListFilters.vue?vue&type=script&lang=js&"
export * from "./MainListFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports